import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getHreflangAndCanonical, getLanguageFromPathname } from '../i18n/routes'

export default function MetaTags({ title, description, canonical, customHreflangs }) {
  const location = useLocation()

  useEffect(() => {
    const currentLang = getLanguageFromPathname(location.pathname)
    const { canonicalUrl, hreflangs } = getHreflangAndCanonical(location.pathname)

    // 1. Title
    const brandSuffix = 'M.Rou Transport'
    let formattedTitle = 'M.Rou Transport'
    if (title) {
      formattedTitle = title.includes(brandSuffix) ? title : `${title} - ${brandSuffix}`
    } else {
      formattedTitle = currentLang === 'en' 
        ? 'M.Rou Transport | Heavy Haulage, Containers & Freight Logistics' 
        : 'M.Rou Transport | Specialtransport, Containere & Godstransport'
    }
    document.title = formattedTitle

    // Helper to set or create meta tag
    const setMetaTag = (attrName, attrValue, content) => {
      if (!content) return
      let el = document.querySelector(`meta[${attrName}="${attrValue}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attrName, attrValue)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    // 2. Meta Description
    if (description) {
      setMetaTag('name', 'description', description)
      setMetaTag('property', 'og:description', description)
      setMetaTag('name', 'twitter:description', description)
    }

    // 3. OpenGraph Title & General
    setMetaTag('property', 'og:title', formattedTitle)
    setMetaTag('name', 'twitter:title', formattedTitle)
    setMetaTag('property', 'og:type', 'website')

    // 4. HTML lang attribute
    document.documentElement.lang = currentLang

    // 5. OpenGraph Locale
    setMetaTag('property', 'og:locale', currentLang === 'en' ? 'en_US' : 'da_DK')
    setMetaTag('property', 'og:locale:alternate', currentLang === 'en' ? 'da_DK' : 'en_US')

    // 6. Canonical URL
    const activeCanonical = canonical || canonicalUrl
    let canonicalLink = document.querySelector('link[rel="canonical"]')
    if (!canonicalLink) {
      canonicalLink = document.createElement('link')
      canonicalLink.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalLink)
    }
    canonicalLink.setAttribute('href', activeCanonical)
    setMetaTag('property', 'og:url', activeCanonical)

    // 7. Hreflang Tags (da, en, x-default)
    const activeHreflangs = customHreflangs || hreflangs
    // Remove existing hreflang tags to prevent duplicate build-up
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove())

    activeHreflangs.forEach(({ lang, url }) => {
      const link = document.createElement('link')
      link.setAttribute('rel', 'alternate')
      link.setAttribute('hreflang', lang)
      link.setAttribute('href', url)
      document.head.appendChild(link)
    })
  }, [title, description, canonical, customHreflangs, location.pathname])

  return null
}
